import React from "react";

import { faBarsFilter } from "@fortawesome/pro-regular-svg-icons";

import Badge from "../../../Badge";
import IconButton from "../../IconButton";

type FilterButtonProps = {
	onClick: () => void;
	numberOfFilters?: number;
	disabled?: boolean;
	disabledTooltip?: boolean;
	testid?: string;
};

/**
 * @deprecated Use the ButotnIcon component from the py-components package instead
 */
const FilterButton = ({
	onClick,
	numberOfFilters = 0,
	disabled = false,
	disabledTooltip = false,
	testid,
}: FilterButtonProps) => {
	let badgeTitle: string | undefined;
	if (!disabledTooltip) {
		badgeTitle = `${numberOfFilters} filter${numberOfFilters === 1 ? "" : "s"} applied`;
	}

	return (
		<Badge title={badgeTitle} count={numberOfFilters}>
			<IconButton
				icon={faBarsFilter}
				onClick={onClick}
				disabled={disabled}
				square
				isHollow={true}
				testId={testid}
			/>
		</Badge>
	);
};

export default FilterButton;
